import React, { useEffect, useMemo, useContext  } from 'react';
import { useGLTF } from '@react-three/drei';

import { useFrame } from '@react-three/fiber';
import { AnimationMixer } from 'three';
import { settings } from '../../../config';
import { LoadingContext } from '../../../context/LoadingContext';

// Assume your GLB file is in the public folder
const bureauPath = `${settings.BASE_PATH}/assets/3d/bureau.glb`;

export default function Bureau() {
  const { setIsBureauLoaded } = useContext(LoadingContext);
  const { animations, scene }: any = useGLTF(bureauPath, true);

  const animationClip = animations[0];
  const mixer = useMemo(() => new AnimationMixer(scene), [scene]);

  useEffect(() => {
    const action = mixer.clipAction(animationClip);
    // Zet de snelheid van de animatie lager voor minder heftige beweging
    action.timeScale = 0.6;
    action.play();

    // Signal that bureau is loaded
    setIsBureauLoaded(true);

    return () => {
      action.stop();
    }
  }, [mixer, animationClip, setIsBureauLoaded]);

  useFrame((_, delta) => mixer.update(delta));
  
  return (
      <group scale={0.45} position={[1.2,-0.2,0]} rotation={[1.6, -1.6, -5]}>
        <directionalLight intensity={4}/>
        <primitive object={scene} />
      </group>
  );
};